<template>
    <hp6-pagination-control
      :id="`thePage-${type}`"
      :page-count="pageCount"
      @hp6Change="eventHandler"
    />
  </template>
  
  <script setup>

    defineProps({
        type: String,
        pageCount: Number
    })

    const emit = defineEmits(['update:modelValue'])

    const eventHandler = (event) => {
      emit('update:modelValue', event.detail.value)
    }

  </script>
